import React from "react";
import { Info } from "lucide-react";
import "../../assets/css/PriceValue.css";

const isEmptyValue = (val) => {
    if (val === null || val === undefined) return true;

    const str = String(val).trim();

    return (
        str === "" ||
        str === "0" ||
        str === "0.00" ||
        str === "Rs. 0" ||
        str === "Rs. 0.00"
    );
};

const formatValue = (val) => {
    if (isEmptyValue(val)) return "-";
    return String(val);
};

export default function PriceValue({
    lineAmount,
    lineDiscount,
    priceRemark,
}) {
    const showDiscount = !isEmptyValue(lineDiscount);

    return (
        <div className="price-wrapper">
            {/* Line Amount */}
            <div className="line-amount">
                {formatValue(lineAmount)}
            </div>

            {/* Line Discount */}
            {showDiscount && (
                <div className="line-discount strike">
                    {lineDiscount}
                </div>
            )}

            {/* Price Remark */}
            {priceRemark && String(priceRemark).trim() !== "" && (
                <div className="price-remark">
                    <Info size={14} />
                    <span className="remark-tooltip">
                        {priceRemark}
                    </span>
                </div>
            )}
        </div>
    );
}
